import { Transform } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsPhoneNumber, Length } from 'class-validator';

export class CreateDistrictDto {
	@IsNotEmpty({ message: 'Name is required' })
	name: string;

	districtLinguistLinkId?: any;
	linkType?: string;

	@IsOptional()
	@Transform(({ value }) => (value === '' ? undefined : value))
	@IsPhoneNumber('US', { message: 'Phone number must be a valid phone number' })
	contactNumber?: string;
}
